<template>
  <div :class="className">
    <div class="sticky-select">
      <q-select
        label="Select company"
        v-model="companyFilter"
        outlined
        :disable="companies.length === 0 || loading"
        label-color="grey-7"
        color="grey-7"
        :options="companies"
        :option-label="(company) => company.name"
        :option-value="(company) => company.id"
        dense
      >
        <template v-slot:no-option>
          <q-item>
            <q-item-section class="text-italic text-grey">
              There is no options.
            </q-item-section>
          </q-item>
        </template>
        <template v-slot:append>
          <q-icon
            size="15px"
            style="margin-top:3px"
            v-if="!!companyFilter.id"
            class="cursor-pointer"
            name="fas fa-times"
            @click="companyFilter = ''"
            @click.stop="!companyFilter.id"
          />
        </template>
      </q-select>
    </div>
    <div class="sticky-location">
      <q-select
        label="Select Location"
        v-model="multiFilter"
        outlined
        :display-value="shorter"
        multiple
        :disable="locations.length === 0 || loading || !companyFilter.id"
        label-color="grey-7"
        color="grey-7"
        :options="locations"
        dense
      >
        <template v-slot:no-option>
          <q-item>
            <q-item-section class="text-italic text-grey">
              There is no options.
            </q-item-section>
          </q-item>
        </template>
        <template v-slot:append>
          <q-icon
            size="15px"
            style="margin-top:3px"
            v-if="!!multiFilter.length > 0"
            class="cursor-pointer"
            name="fas fa-times"
            @click="multiFilter = []"
            @click.stop="!multiFilter.length === 0"
          />
        </template>
        <template v-slot:option="locations">
          <q-item
            :disable="loading"
            @click="locationFilterPusher(locations.opt)"
            dense
            clickable
            v-ripple
          >
            <q-item-section side top>
              <q-checkbox
                size="xs"
                v-model="multiFilter"
                :val="locations.opt"
              />
            </q-item-section>
            <q-item-section>{{ locations.opt.code }}</q-item-section>
          </q-item>
        </template>
      </q-select>
    </div>
    <div class="sticky-location">
      <q-select
        label="Select Status"
        v-model="statusFilter"
        outlined
        :display-value="statusShorter"
        multiple
        label-color="grey-7"
        color="grey-7"
        :options="statuses()"
        dense
      >
        <template v-slot:append>
          <q-icon
            size="15px"
            style="margin-top: 3px"
            v-if="!!statusFilter.length > 0"
            class="cursor-pointer"
            name="fas fa-times"
            @click="statusFilter = []"
            @click.stop="!statusFilter.length === 0"
          />
        </template>
        <template v-slot:option="status">
          <q-item
            :disable="loading"
            @click="statusFilterPusher(status.opt)"
            dense
            clickable
            v-ripple
          >
            <q-item-section side top>
              <q-checkbox
                size="xs"
                v-model="statusFilter"
                :val="status.opt"
              />
            </q-item-section>
            <q-item-section>{{ status.opt.label }}</q-item-section>
          </q-item>
        </template>
        <template v-slot:no-option>
          <q-item>
            <q-item-section class="text-italic text-grey">
              There is no options.
            </q-item-section>
          </q-item>
        </template>
      </q-select>
    </div>
    <!-- provider
    <div class="sticky-location">
      <q-select
        label="Select Provider"
        v-model="provider"
        outlined
        :option-label="pro => pro.name"
        :option-value="pro => pro.key"
        :options="providers"
        label-color="grey-7"
        color="grey-7"
        dense
      >
        <template v-slot:no-option>
          <q-item>
            <q-item-section class="text-italic text-grey">
              There is no options.
            </q-item-section>
          </q-item>
        </template>
        <template v-slot:append>
          <q-icon
            size="15px"
            style="margin-top:3px"
            v-if="provider"
            class="cursor-pointer"
            name="fas fa-times"
            @click="provider = ''"
          />
        </template>
      </q-select>
    </div> -->
    <slot name="activator"></slot>
  </div>
</template>

<script>
import {defaultStatuses, statuses} from "@/enums";

export default {
  data() {
    return {
      providers: [
        // { name: "JD Power", key: "jd_power" },
        { name: "Manheim", key: "manheim" },
      ],
      localeSearch: this.$store.state.analysis.search,
    };
  },
  props: {
    className: String,
  },
  mounted() {
    this.statusFilter = defaultStatuses;
  },
  computed: {
    provider: {
      get() {
        return this.$store.state.analysis.provider;
      },
      set(val) {
        this.$store.commit("analysis/SET_PROVIDER", val);
      },
    },
    filterCount: {
      get() {
        return this.$store.state.analysis.filterCount;
      },
      set(val) {
        this.$store.commit("analysis/SET_FILTER_COUNT", val);
      },
    },
    loading: {
      get() {
        return this.$store.state.analysis.loading;
      },
      set(val) {
        this.$store.commit("analysis/SET_LOADING", val);
      },
    },
    shorter() {
      if (this.multiFilter.length > 0 && this.multiFilter.length < 2) {
        return this.multiFilter[0].code;
      } else if (this.multiFilter.length > 1) {
        return `${this.multiFilter[0].code} +${this.multiFilter.length - 1}`;
      }
    },
    multiFilter: {
      get() {
        return this.$store.state.analysis.multiFilter;
      },
      set(val) {
        this.$store.commit("analysis/SET_MULTI_FILTER", val);
      },
    },
    statusShorter() {
      if (this.statusFilter.length > 0 && this.statusFilter.length < 2) {
        return this.statusFilter[0].label;
      } else if (this.statusFilter.length > 2) {
        return `${this.statusFilter[0].label}, ${this.statusFilter[1].label} +${this.statusFilter.length - 2}`;
      }
    },
    statusFilter: {
      get() {
        return this.$store.state.analysis.statusFilter;
      },
      set(val) {
        this.$store.commit("analysis/SET_STATUS_FILTER", val);
      },
    },
    companyFilter: {
      get() {
        return this.$store.state.analysis.companyFilter;
      },
      set(val) {
        this.$store.commit("analysis/SET_COMPANY_FILTER", val);
      },
    },
    locations: {
      get() {
        return this.$store.state.vehicle.locations;
      },
      set(val) {
        this.$store.commit("vehicle/SET_LOCATIONS", val);
      },
    },
    companies: {
      get() {
        return this.$store.state.company.companies;
      },
      set(val) {
        this.$store.commit("company/SET_USER_COMPANIES", val);
      },
    },
    search: {
      get() {
        return this.$store.state.analysis.search;
      },
      set(val) {
        this.$store.commit("analysis/SET_SEARCH", val);
      },
    },
    query() {
      return this.$store.state.analysis.query;
    },
  },
  watch: {
    search(n, o) {
      this.localeSearch = n;
    },
  },
  methods: {
    statuses() {
      return statuses
    },
    applySearch() {
      this.search = this.localeSearch;
    },
    resetSearch() {
      this.search = "";
      this.localeSearch = "";
    },
    locationFilterPusher(location) {
      if (this.multiFilter.some((item) => item.id === location.id)) {
        const index = this.multiFilter
          .map((item) => item.id)
          .indexOf(location.id);
        if (index !== -1) {
          this.$store.commit("analysis/REMOVE_MULTI_FILTER", index);
        }
      } else {
        this.multiFilter = [...this.multiFilter, location];
      }
    },
    statusFilterPusher(status) {
      if (this.statusFilter.some(item => item.value === status.value)) {
        const index = this.statusFilter
          .map(item => item.value)
          .indexOf(status.value);
        if (index !== -1) {
          this.$store.commit("analysis/REMOVE_STATUS_FILTER", index);
        }
      } else {
        this.statusFilter = [...this.statusFilter, status];
      }
    },
  },
};
</script>
